import type { PrintoutColumn, PrintoutColumnType } from "../types";

interface ExpandColumnsArgs {
	enabledColumns: PrintoutColumn[];
	staffPerRow: number;
	rowGroupingBy: PrintoutColumnType[];
}

/**
 * Expand the column list when `staffPerRow > 1` (mapping §8.1).
 *
 * Merge columns (those in `rowGroupingBy`) appear **once at the start** of the row. All other
 * columns are duplicated `staffPerRow` times in sequence. The packing rule (the row-filling step
 * elsewhere) is responsible for never packing rows that disagree on any merge-column value —
 * that constraint isn't expressed in the column layout itself.
 *
 * `staffPerRow <= 1` → no expansion, returns the input unchanged.
 */
export const expandColumnsForStaffPerRow = ({ enabledColumns, staffPerRow, rowGroupingBy }: ExpandColumnsArgs): PrintoutColumn[] => {
	if (staffPerRow <= 1) return enabledColumns;
	const mergeColumns = enabledColumns.filter((col) => rowGroupingBy.includes(col.type));
	const nonMergeColumns = enabledColumns.filter((col) => !rowGroupingBy.includes(col.type));
	const expanded: PrintoutColumn[] = [...mergeColumns];
	for (let i = 0; i < staffPerRow; i++) {
		for (const col of nonMergeColumns) {
			expanded.push({ ...col });
		}
	}
	return expanded;
};
